import { getLogger } from '@ravago/shared/logging/client';
import { ServerConfig } from '@ravago/shared/page-data/models/config/server-config.model';

import { ContentfulConfigError, ContentfulTokenKind } from '../../errors';

export const requireContentfulToken = (token: string | undefined, tokenKind: ContentfulTokenKind, context?: string): string => {
  if (!token) {
    const error = new ContentfulConfigError({ token: tokenKind, context });

    getLogger().withError(error).withMetadata({ tokenKind, context }).error('Missing Contentful token');

    throw error;
  }

  return token;
};

export const resolveContentfulDeliveryToken = (contentful: ServerConfig['contentful'], context?: string): string => {
  const tokenKind: ContentfulTokenKind = contentful.preview ? 'preview' : 'access';
  const token = contentful.preview ? contentful.previewToken : contentful.accessToken;

  return requireContentfulToken(token, tokenKind, context);
};
